import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkOperationsToolbar = ({ selectedCount, onBulkStatusChange, onBulkCapacityUpdate, onBulkExport, onClearSelection }) => {
  const [showBulkMenu, setShowBulkMenu] = useState(false);

  const statusOptions = [
    { value: 'active', label: 'Set to Active' },
    { value: 'inactive', label: 'Set to Inactive' },
    { value: 'maintenance', label: 'Set to Maintenance' }
  ];

  const exportOptions = [
    { value: 'pdf', label: 'Export as PDF' },
    { value: 'excel', label: 'Export as Excel' },
    { value: 'csv', label: 'Export as CSV' }
  ];

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="bg-primary/10 border-b border-primary/20 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} color="var(--color-primary)" strokeWidth={2} />
            <span className="text-sm font-medium text-foreground">
              {selectedCount} {selectedCount === 1 ? 'yard' : 'yards'} selected
            </span>
          </div>
          <button
            onClick={onClearSelection}
            className="text-sm text-primary hover:underline"
          >
            Clear selection
          </button>
        </div>

        <div className="flex items-center space-x-2">
          <div className="relative">
            <Button
              variant="default"
              size="sm"
              iconName="Settings"
              iconPosition="left"
              onClick={() => setShowBulkMenu(!showBulkMenu)}
            >
              Bulk Actions
            </Button>

            {showBulkMenu && (
              <>
                <div
                  className="fixed inset-0 z-[110]"
                  onClick={() => setShowBulkMenu(false)}
                ></div>
                <div className="absolute right-0 mt-2 w-64 bg-popover border border-border rounded-md shadow-elevation-2 z-[120] animate-slide-in">
                  <div className="py-2">
                    <div className="px-4 py-2">
                      <label className="block text-xs font-medium text-muted-foreground mb-2">Change Status</label>
                      <Select
                        options={statusOptions}
                        value=""
                        onChange={(value) => {
                          onBulkStatusChange(value);
                          setShowBulkMenu(false);
                        }}
                        placeholder="Select status..."
                      />
                    </div>
                    <div className="border-t border-border my-2"></div>
                    <button
                      onClick={() => {
                        onBulkCapacityUpdate();
                        setShowBulkMenu(false);
                      }}
                      className="flex items-center w-full px-4 py-2 text-sm text-foreground hover:bg-muted/50 transition-hover"
                    >
                      <Icon name="TrendingUp" size={16} strokeWidth={2} className="mr-3" />
                      Update Capacity
                    </button>
                    <div className="border-t border-border my-2"></div>
                    <div className="px-4 py-2">
                      <label className="block text-xs font-medium text-muted-foreground mb-2">Export Selected</label>
                      <Select
                        options={exportOptions}
                        value=""
                        onChange={(value) => {
                          onBulkExport(value);
                          setShowBulkMenu(false);
                        }}
                        placeholder="Select format..."
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={() => onBulkExport('pdf')}
          >
            Export
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkOperationsToolbar;